import React from 'react';
import { Icon, Input as UIInput } from 'lmc-ui-library';
import { Icon as NewUiIcon, Input as NewUIInput } from 'lmc-ui-library-rebrand';
import { ComponentProps } from 'lmc-ui-library-rebrand/lib/components/atoms/Input/Input.types';

type Remove<TType, Remove extends string> = TType extends Remove ? never : TType;

interface BackwardsCompatibleProps extends Omit<ComponentProps, 'state'> {
  state?: Remove<ComponentProps['state'], 'highlighted'>;
}

interface Props extends BackwardsCompatibleProps {
  newUi?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, Props>(({ state, newUi = false, ...props }, ref) => {
  const componentProps: BackwardsCompatibleProps = { ...props };
  const IconComponent = newUi ? NewUiIcon : Icon;
  const InputComponent = newUi ? NewUIInput : UIInput;
  if (state === 'error') {
    componentProps.state = 'error';
    componentProps.rightIcon = (stateColor) => <IconComponent type="error" color={stateColor} />;
  }

  if (state === 'warning') {
    componentProps.state = 'warning';
    componentProps.rightIcon = (stateColor) => <IconComponent type="warning" color={stateColor} />;
  }

  return <InputComponent {...componentProps} ref={ref} />;
});

export default Input;
